"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { clearIdentity, disableAnalytics, identify, initAnalytics, trackPageView } from "@/services/analytics/mixpanel";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
export default function MixpanelSetup() {
  const $ = _c(17);
  const pathname = usePathname();
  const {
    connectedProfile
  } = useAuth();
  const {
    performanceConsent
  } = useCookieConsent();
  const lastTrackedPathRef = useRef(null);
  const identifiedProfileIdRef = useRef(null);
  const hasConsent = performanceConsent === true;
  let t0;
  let t1;
  if ($[0] !== hasConsent) {
    t0 = () => {
      if (!hasConsent) {
        disableAnalytics();
        lastTrackedPathRef.current = null;
        identifiedProfileIdRef.current = null;
        return;
      }
      initAnalytics();
    };
    t1 = [hasConsent];
    $[0] = hasConsent;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== connectedProfile || $[4] !== hasConsent) {
    t2 = () => {
      if (!hasConsent) {
        return;
      }
      const profileId = connectedProfile?.id !== undefined && connectedProfile.id !== null ? String(connectedProfile.id) : null;
      if (!profileId) {
        if (identifiedProfileIdRef.current !== null) {
          clearIdentity();
          identifiedProfileIdRef.current = null;
        }
        return;
      }
      if (identifiedProfileIdRef.current === profileId) {
        return;
      }
      identify(profileId);
      identifiedProfileIdRef.current = profileId;
    };
    $[3] = connectedProfile;
    $[4] = hasConsent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = connectedProfile?.id;
  let t4;
  if ($[6] !== hasConsent || $[7] !== t3) {
    t4 = [t3, hasConsent];
    $[6] = hasConsent;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t2, t4);
  let t5;
  if ($[9] !== connectedProfile || $[10] !== hasConsent || $[11] !== pathname) {
    t5 = () => {
      if (!hasConsent || !pathname) {
        return;
      }
      if (lastTrackedPathRef.current === pathname) {
        return;
      }
      lastTrackedPathRef.current = pathname;
      trackPageView(pathname, {
        has_connected_profile: connectedProfile?.id !== undefined && connectedProfile.id !== null
      });
    };
    $[9] = connectedProfile;
    $[10] = hasConsent;
    $[11] = pathname;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = connectedProfile?.id;
  let t7;
  if ($[13] !== hasConsent || $[14] !== pathname || $[15] !== t6) {
    t7 = [t6, hasConsent, pathname];
    $[13] = hasConsent;
    $[14] = pathname;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t5, t7);
  return null;
}